import { AxiosInstance } from 'axios';

import { userYearSeasonEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { UserYearSeasonType } from './UserYearSeasonApi.schema';

class UserYearSeasonApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  updateUserYearSeason = async (UserYearSeason: UserYearSeasonType): Promise<void> => {
    return this.#requestInstance.patch(userYearSeasonEndpoints.userYearSeason, {
      seasonId: UserYearSeason.seasonId,
      userId: UserYearSeason.userId,
    });
  };
}

export const userYearSeasonApi = new UserYearSeasonApi(axios);
